import { render, staticRenderFns } from "./industry_jrjg_yw.vue?vue&type=template&id=5ce1ddff&scoped=true&"
import script from "./industry_jrjg_yw.vue?vue&type=script&lang=js&"
export * from "./industry_jrjg_yw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce1ddff",
  null
  
)

export default component.exports